<form [formGroup]="form">
  <pu-simple-input
    formControlName="fullName"
    [isReadonly]="true"
    [label]="'editUser.form.fullName.label' | translate">
  </pu-simple-input>

  <div class="input-wrapper">
    <pu-simple-input
      formControlName="email"
      [label]="'editUser.form.email.label' | translate">
    </pu-simple-input>
    @if (emailCtrl.disabled && !readonlyRights()) {
      <pp-tooltip
        [text]="'editUser.form.emailphone.placeholder' | translate"
        [customContent]="true">
        <div class="tooltip"></div>
      </pp-tooltip>
    }
  </div>

  <div class="input-wrapper">
    <pu-simple-input
      formControlName="phone"
      [label]="'editUser.form.phone.label' | translate">
    </pu-simple-input>
    @if (phoneCtrl.disabled && !readonlyRights()) {
      <pp-tooltip
        [text]="'editUser.form.emailphone.placeholder' | translate"
        [customContent]="true">
        <div class="tooltip"></div>
      </pp-tooltip>
    }
  </div>

  <pu-simple-input
    formControlName="roleName"
    [isReadonly]="true"
    [label]="'editUser.form.role.label' | translate">
  </pu-simple-input>
  <pu-simple-input
    formControlName="orgName"
    [isReadonly]="true"
    [label]="'editUser.form.org.label' | translate">
  </pu-simple-input>
  <pu-simple-input
    formControlName="currency"
    [isReadonly]="true"
    [label]="'editUser.form.currency.label' | translate">
  </pu-simple-input>

  @if (hasChanges()) {
    <button
      class="discard"
      type="button"
      puButton
      size="m"
      uiType="quaternary"
      (click)="discardChanges()"
      translate="editUser.form.btn.discardChanges"></button>
  }

  <div class="pp-form-actions">
    <button
      type="button"
      puButton
      size="m"
      uiType="secondary"
      (click)="close.emit()"
      translate="editUser.form.btn.close"></button>

    @if (!readonlyRights()) {
      <button
        type="button"
        puButton
        size="m"
        [disabled]="form.invalid || !hasChanges()"
        uiType="primary"
        (click)="save()"
        translate="editUser.form.btn.save"></button>
    }
  </div>
</form>
